// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZPel","title":"styles_title__1vk39"};